import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useTotalClaimedYield from '../../../../hooks/web3/vault/useTotalClaimedYield';
import useUserStatistics from '../../../../hooks/web3/vault/useUserStatistics';

const TotalYieldToDate: React.FC = () => {
    const { userStatistics } = useUserStatistics();
    const { totalClaimedYield } = useTotalClaimedYield();

    const totalUnclaimedYield = userStatistics
        ? Object.entries(userStatistics.spools).reduce(
              (total, [_, { userUnrealizedYieldAmount }]) =>
                  (total += userUnrealizedYieldAmount),
              0
          )
        : 0;

    return (
        <Detail
            className='spool-yield'
            title={
                <>
                    <span>Your Total Yield to Date</span>
                    <InfoPopUp>
                        <span>Your Yield to Date:</span>
                        <div className='mt'>
                            <span>Total Yield Withdrawn from Spools:</span>
                            <strong className='block'>
                                ~${formatUSD(totalClaimedYield || 0)}
                            </strong>
                        </div>
                        <div className='mt border-top'>
                            <span>
                                Total Yield Still in Spools, not including performance
                                fees:
                            </span>
                            <strong className='block'>
                                ~${formatUSD(totalUnclaimedYield || 0)}
                            </strong>
                        </div>
                    </InfoPopUp>
                </>
            }
            value={`~$${formatUSD((totalClaimedYield || 0) + totalUnclaimedYield)}`}
        />
    );
};

export default TotalYieldToDate;
